<div class="container-fluid p-3">



  <div class="d-flex gap-1">

    <!-- Date Range -->
    <mat-form-field appearance="outline">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="From" [formControl]="startDate">
        <input matEndDate placeholder="To" [formControl]="endDate">
      </mat-date-range-input>

      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Centre Name</mat-label>
      <mat-select [formControl]="SelectCentre" (selectionChange)="onCentreChange($event)">
        <mat-option value="All">All Centres</mat-option>
        <mat-option value="HeadOffice">Head Office</mat-option>
        <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">
          {{ c.centreName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- Teacher Type -->
    <mat-form-field appearance="outline">
      <mat-label>Teacher Type</mat-label>
      <mat-select [(value)]="teacherType">
        <mat-option value="All">All</mat-option>
        <mat-option value="Teaching Team">Teaching Team</mat-option>
        <mat-option value="Lead Teacher">Lead Teacher</mat-option>
      </mat-select>
    </mat-form-field>




    <mat-form-field  appearance="outline" >
      <mat-label  >Teacher</mat-label>
      <mat-select [(value)]="mTeacher">
        <mat-option value="All">All</mat-option>
        <mat-option *ngFor="let t of teachers$ | async" [value]="t.userName">
          {{ t.userName }}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <button mat-mini-fab (click)="search()" color="accent"><mat-icon>search</mat-icon></button>
    <button mat-mini-fab (click)="clearAll()" color="accent"><mat-icon>clear</mat-icon></button>

  </div>



  <section class="card">
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Education Work Update List</h2>
      </li>

      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' aria-label="Search box" #input>
      </li>
    </ul>
    <ul class="header-buttons mr-2">
      <li>
        <button
          class="mr-2"
          mat-mini-fab
          color="primary"
          (click)="Add()"
          permission="Daily Work Update"
          [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]"
        >
          <mat-icon class="col-white">add</mat-icon>
        </button>
      </li>
      <li>
        <button
          mat-mini-fab
          color="accent"
          (click)="downloadExcelSheet()"
          matTooltip="Download Excel"
          permission="Daily Work Update"
          [permissionTypes]="[PermissionType.EXCEL]"
        >
          <mat-icon>download</mat-icon>
        </button>
      </li>


    </ul>
  </div>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100">

    <ng-container  matColumnDef="sr">
      <th mat-header-cell  *matHeaderCellDef>Sr.No.</th>
      <td mat-cell *matCellDef="let row let i= index">{{i+1}}</td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef style="width: 110px;">Date</th>
      <td mat-cell *matCellDef="let row" style="width: 110px;">
        {{ row.date.toDate() | date }}
      </td>
    </ng-container>

<!--    <ng-container matColumnDef="centreName">-->
<!--      <th mat-header-cell *matHeaderCellDef> Centre </th>-->
<!--      <td mat-cell *matCellDef="let row">{{ getCentreNames(row) }}</td>-->
<!--    </ng-container>-->

    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef> Centre </th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="getCentreNames(row) as c">
          {{ c.first }}
          <span *ngIf="c.extra > 0" style="color:#1a73e8; font-weight:500;">
        + {{ c.extra }} more
      </span>
        </ng-container>
      </td>
    </ng-container>


    <ng-container matColumnDef="submittedBy">
      <th mat-header-cell *matHeaderCellDef>Teacher</th>
      <td mat-cell *matCellDef="let row">{{ row.submittedBy }}</td>
    </ng-container>


<!--    <ng-container matColumnDef="task">-->
<!--      <th mat-header-cell *matHeaderCellDef>Task</th>-->
<!--      <td mat-cell *matCellDef="let row">{{ row.task }}</td>-->
<!--    </ng-container>-->

<!--    <ng-container matColumnDef="remarks">-->
<!--      <th mat-header-cell *matHeaderCellDef>Remarks</th>-->
<!--      <td mat-cell *matCellDef="let row">{{ row.remarks }}</td>-->
<!--    </ng-container>-->

    <ng-container matColumnDef="task">
      <th mat-header-cell *matHeaderCellDef>Task</th>

      <td mat-cell *matCellDef="let row">
        <div
          style="white-space: pre-line;"
          [matTooltip]="row.task"
          matTooltipClass="task-tooltip"
          matTooltipPosition="above"
          matTooltipShowDelay="300"
        >
          {{ row.showFullTask ? row.task : (row.task | slice:0:20) }}

          <ng-container *ngIf="row.task?.length > 110">
            <a
              href="javascript:void(0)"
              (click)="row.showFullTask = !row.showFullTask"
              style="color:#1976d2; margin-left:4px;"
            >
              {{ row.showFullTask ? 'See less' : '... See more' }}
            </a>
          </ng-container>
        </div>
      </td>
    </ng-container>


    <ng-container matColumnDef="remarks">
      <th mat-header-cell *matHeaderCellDef>Remarks</th>
      <td mat-cell *matCellDef="let row">
        <div>
          {{ row.showFullRemarks ? row.remarks : (row.remarks | slice:0:110) }}
          <ng-container *ngIf="row.remarks?.length > 110">
            <a href="javascript:void(0)"
               (click)="row.showFullRemarks = !row.showFullRemarks"
               style="color: #1976d2;  margin-left: 4px;">
              {{ row.showFullRemarks ? 'See less' : '... See more' }}
            </a>
          </ng-container>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex">
          <button color="accent" mat-icon-button (click)="openViewDialog(element)" matTooltip="View" permission="Daily Work Update" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]" ><mat-icon>remove_red_eye</mat-icon>&nbsp;</button>
          <button  mat-icon-button color="primary" permission="Daily Work Update" [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]" (click)="viewEdit(element?.id)" matTooltip="Edit"><mat-icon>edit</mat-icon></button>
          <button permission="Daily Work Update" [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]" mat-icon-button color="warn" (click)="delete(element.id)" matTooltip="Delete"><mat-icon>delete</mat-icon></button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

  <mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 200]" showFirstLastButtons></mat-paginator>
  </section>
</div>
